import ChevronRight from '@mui/icons-material/ChevronRight';
import { Box, Typography } from '@mui/material';
import * as Colors from '@mui/material/colors';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import React from 'react';
import { BLACK500_12_PERCENT } from '../values/color';

type GaugeProps = {
    title: string;
    status: string;
    subtitle1?: string;
    subtitle2?: string;
    color: string;
    onClick?: () => void;
};

export const StatusGaugeCard: React.FC<GaugeProps> = ({
    title,
    status,
    subtitle1,
    subtitle2,
    color,
    onClick,
    ...props
}) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: 248,
            border: 1,
            borderColor: BLACK500_12_PERCENT,
        }}
        {...props}
        onClick={onClick}
    >
        <Gauge
            value={100}
            startAngle={0}
            endAngle={360}
            innerRadius="80%"
            outerRadius="100%"
            text={status}
            width={110}
            height={110}
            sx={{
                [`& .${gaugeClasses.valueArc}`]: {
                    fill: color,
                    opacity: 0.15,
                },
                [`& .${gaugeClasses.valueText} text`]: {
                    fill: color,
                    fontWeight: 600,
                    fontSize: 11,
                    size: 8,
                    lineHeight: '100%',
                    letterSpacing: 2,
                    horizontalAlignment: 'center',
                    verticalAlignment: 'middle',
                    textTransform: 'uppercase',
                },
            }}
        />
        <Box
            sx={{
                width: 168,
                height: 65,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                alignItems: 'left',
            }}
        >
            <Typography
                variant="button"
                sx={{
                    fontWeight: 600,
                    fontSize: 12,
                    lineHeight: '100%',
                    letterSpacing: 2,
                    textTransform: 'uppercase',
                    paragraphSpacing: 8,
                }}
            >
                {title}
            </Typography>
            {subtitle1 && (
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 600,
                        fontSize: 16,
                        lineHeight: '100%',
                        letterSpacing: 0,
                        paragraphSpacing: 8,
                    }}
                >
                    {subtitle1}
                </Typography>
            )}
            {subtitle2 && (
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 300,
                        fontSize: 12,
                        lineHeight: '200%',
                        letterSpacing: 0,
                        paragraphSpacing: 8,
                    }}
                >
                    {subtitle2}
                </Typography>
            )}
        </Box>
        {onClick && (
            <ChevronRight
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    color: Colors.grey[500],
                }}
                data-testid="ChevronRightIcon"
                aria-label="details"
            />
        )}
    </Box>
);
